import React, { Children } from 'react';
import { CalendarIcon, BriefcaseIcon, GraduationCapIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function About() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="about" className="py-20 bg-gray-50 px-4" data-id="element-13">
      <div className="container mx-auto max-w-5xl" data-id="element-14">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-16">
            About Me
          </h2>
          <div className="w-20 h-1 bg-purple-600 mx-auto" data-id="element-17"></div>
        </motion.div>
        <div className="grid md:grid-cols-2 gap-12" data-id="element-18">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-19">
            <h3 className="text-2xl font-semibold text-gray-800 mb-4" data-id="element-20">
              My Story
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-21">
              Hello! I'm ADIATU Habeeb, a passionate IT professional with
              expertise in networking and cybersecurity. I specialize in
              implementing secure network infrastructures, monitoring systems
              for vulnerabilities, and ensuring robust security protocols are in
              place.
            </p>
            <p className="text-gray-600 mb-4" data-id="element-22">
              My experience extends to operating system management and
              optimization, with a focus on both Windows and Linux environments.
              I'm also skilled in PC troubleshooting and repair, helping to
              diagnose and resolve hardware and software issues efficiently.
            </p>
            <p className="text-gray-600" data-id="element-23">
              I'm committed to staying current with the latest security threats
              and technological advancements to provide the best solutions for
              modern IT challenges.
            </p>
          </motion.div>
          <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true
        }} data-id="element-24">
            <h3 className="text-2xl font-semibold text-gray-800 mb-4" data-id="element-25">
              Experience & Education
            </h3>
            <div className="space-y-6" data-id="element-26">
              <motion.div className="flex" variants={itemVariants} data-id="element-27">
                <div className="mr-4 mt-1" data-id="element-28">
                  <BriefcaseIcon size={24} className="text-purple-600" data-id="element-29" />
                </div>
                <div data-id="element-30">
                  <h4 className="text-xl font-medium text-gray-800" data-id="element-31">
                    Web Developer
                  </h4>
                  <p className="text-gray-600" data-id="element-32">Freelance • 2018 - 2020</p>
                </div>
              </motion.div>
              <motion.div className="flex" variants={itemVariants} data-id="element-33">
                <div className="mr-4 mt-1" data-id="element-34">
                  <BriefcaseIcon size={24} className="text-purple-600" data-id="element-35" />
                </div>
                <div data-id="element-36">
                  <h4 className="text-xl font-medium text-gray-800" data-id="element-37">
                    IT Support Technician
                  </h4>
                  <p className="text-gray-600" data-id="element-38">Cyber Café • 2015 - 2020</p>
                </div>
              </motion.div>
              <motion.div className="flex" variants={itemVariants} data-id="element-39">
                <div className="mr-4 mt-1" data-id="element-40">
                  <GraduationCapIcon size={24} className="text-purple-600" data-id="element-41" />
                </div>
                <div data-id="element-42">
                  <h4 className="text-xl font-medium text-gray-800" data-id="element-43">
                    Bachelor's in Networking
                  </h4>
                  <p className="text-gray-600" data-id="element-44">
                    Institut Ivoirien de Technology • 2022 - 2025
                  </p>
                </div>
              </motion.div>
              <motion.div className="flex" variants={itemVariants} data-id="element-45">
                <div className="mr-4 mt-1" data-id="element-46">
                  <GraduationCapIcon size={24} className="text-purple-600" data-id="element-47" />
                </div>
                <div data-id="element-48">
                  <h4 className="text-xl font-medium text-gray-800" data-id="element-49">
                    Certificate in Cisco Networking
                  </h4>
                  <p className="text-gray-600" data-id="element-50">
                    Crawford University • 2017 - 2019
                  </p>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}